import { render, staticRenderFns } from "./contentCourseLectureExamTagLevelCreate.vue?vue&type=template&id=49c74c5a&"
import script from "./contentCourseLectureExamTagLevelCreate.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureExamTagLevelCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports